module.exports = __webpack_public_path__ + "static/media/10_1.62e615d9.jpg";